import { Grid } from '@material-ui/core'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandMoreIcon from '@material-ui/core/SvgIcon'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import React from 'react'
import { CustomH3, ExpansionPanelDetailsStyle, ExpansionPanelStyle, ExpansionPanelSummaryStyle, ContentWrapper } from './styles'

export const ContentRenderer = ({ page, contentKey, expanded, clickEvent }) => {
  if (!page) {
    return null
  }
  return (
    <Grid container spacing={8}>
      <Grid item xs={12}>
        <ExpansionPanel
          style={{
            backgroundColor: 'transparent',
            boxShadow: 'none'
          }}
          defaultExpanded={expanded || false}
          data-content={contentKey}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} onClick={clickEvent} style={ExpansionPanelSummaryStyle}>
            <CustomH3
              style={{ margin: 0 }}
            >
              <span dangerouslySetInnerHTML={{ __html: page.title }} />
            </CustomH3>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container>
              {page.items.map((item) => (
                <Grid item xs={12}>
                  <ExpansionPanel style={ExpansionPanelStyle}>
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      style={ExpansionPanelSummaryStyle}
                    >
                      {item.title}
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails style={ExpansionPanelDetailsStyle}>
                      <ContentWrapper
                        dangerouslySetInnerHTML={{ __html: item.body }}
                      />
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              ))}
            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid>
    </Grid>
  )
}
